import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';
import { useState } from 'react';

import { MultiClassDiscount } from './multi-class';
import { MultiStudentDiscount } from './multi-student';

export function Discounts() {
  const [activeTab, setActiveTab] = useState<string>('multi-student');
  const [discountRules, setDiscountRules] = useState<string | null>(null);

  const tabs = [
    { id: 'multi-student', label: 'Multi-Student' },
    { id: 'multi-class', label: 'Multi-Class' },
  ];

  return (
    <div className='min-h-screen min-w-0'>
      <Link className='mb-6 flex min-w-0 items-center gap-2 sm:mb-8' to='/dashboard'>
        <CircleArrowLeft className='size-6 shrink-0' />
        <span className='text-lg font-semibold'>Back to Dashboard</span>
      </Link>
      <div className='mx-auto min-w-0 max-w-7xl px-0 py-4 sm:px-6 sm:py-8 lg:px-8'>
        <div className='rounded-lg bg-white shadow'>
          <div className='border-b border-gray-200 px-4 py-6 sm:px-8'>
            <h1 className='text-2xl font-semibold text-gray-900'>
              Tuition Discounts
            </h1>
            <p className='mt-2 text-sm text-gray-500'>
              Configure discount rules for multiple students or classes
            </p>
          </div>

          <div>
            <div className='border-b border-gray-200'>
              <div className='flex flex-col space-y-4 px-4 py-4 sm:px-8'>
                <nav className='flex' aria-label='Tabs'>
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => {
                        setActiveTab(tab.id);
                      }}
                      className={`relative px-1 py-4 ${
                        activeTab === tab.id
                          ? 'border-b-2 border-yellow-400 text-yellow-400'
                          : 'text-gray-500 hover:border-gray-300 hover:text-gray-700'
                      } -mb-px mr-4 text-sm font-medium sm:mr-8`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </nav>
              </div>
            </div>

            <div className='p-4 sm:p-8'>
              {activeTab === 'multi-student' && (
                <>
                  <MultiStudentDiscount
                    discountRules={discountRules}
                    setDiscountRules={setDiscountRules}
                  />
                </>
              )}
              {activeTab === 'multi-class' && (
                <>
                  <MultiClassDiscount
                    discountRules={discountRules}
                    setDiscountRules={setDiscountRules}
                  />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
